/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Footnote_TitleInputs */

const en_admin_funnel_footnote_title = /** @type {(inputs: Admin_Funnel_Footnote_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definitions`)
};

/**
* | output |
* | --- |
* | "Definitions" |
*
* @param {Admin_Funnel_Footnote_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_footnote_title = /** @type {((inputs?: Admin_Funnel_Footnote_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Footnote_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_footnote_title(inputs)
});
export { admin_funnel_footnote_title as "admin.funnel.footnote.title" }